module.exports = __webpack_public_path__ + "static/media/vue-js.c10d7be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/vue-js.png
// module id = 623
// module chunks = 147